import useListEmployeeDeliveryData, {
  listEmployeeDeliveryConfigs,
} from './useListEmployeeDeliveryData'
import useListLocationDeliveryDayTrendsData, {
  listLocationDeliveryDayTrendsDataConfigs,
} from './useListLocationDeliveryDayTrendsData'
import useListLocationGroupDeliveryData, {
  listLocationGroupDeliveryDataConfigs,
} from './useListLocationGroupDeliveryData'

export const configs = {
  listLocationGroupDeliveryData: listLocationGroupDeliveryDataConfigs,
  listEmployeeDeliveryData: listEmployeeDeliveryConfigs,
  listLocationDeliveryDayTrendsData: listLocationDeliveryDayTrendsDataConfigs,
}

export const api = {
  listLocationGroupDeliveryData: useListLocationGroupDeliveryData,
  listEmployeeDeliveryData: useListEmployeeDeliveryData,
  listLocationDeliveryDayTrendsData: useListLocationDeliveryDayTrendsData,
}
